import { merge as _merge } from "lodash";

const defaultState = {
  data: [],
  shift_data: {},
  loading: false,
  error: false,
};

const doorCrews = function (state = defaultState, action) {
  let target, data;

  switch (action.type) {
    case "SET_DOOR_CREWS":
      console.log("DOOR CREWS", state, action.data)
      // const newState = { ...state, data: action.data };
      const newState = {...state}
        action.data.forEach((seatSet, idx) => {
            newState.data[idx] = _merge({}, newState.data[idx] ?? {}, seatSet);
        })
      console.log("SETTING ", newState)
      return newState;

    case "SET_DOOR_CREWS_SHIFT_DATA":
      const newState2 = { ...state, shift_data: action.data };
      return newState2;

    case "INSERT_DOOR_CREW":
      return { ...state, data: [...state.data, action.data] };

    case "REMOVE_DOOR_CREW":
      return {
        ...state,
        data: [...state.data.filter((d) => d.id !== action.data)],
      };

    case "UPDATE_DOOR_CREW":
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target < 0) return state;
      data[target] = action.data;
      return { ...state, data };

    case "SET_DOOR_CREWS_LOADING":
      return {
        ...state,
        loading: action.data,
      };

    case "SET_DOOR_CREWS_ERROR":
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default doorCrews;
